import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import NProgress from 'nprogress'
import GoogleAnalytics from 'react-ga';

import PlayButton from '../PlayButton';
import ElementShortcuts from '../ElementShortcuts';
import TagList from '../TagList';
import Grid from '../Grid';

import Notification from '../../services/Notification.js'
import Train from '../../services/train.js';
import User from '../../services/User.js';
import NumberUtils from '../../services/NumberUtils.js';

import '../../../css/Track.css';
import '../../../css/elementPage.css';

class Track extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      userData: {}
    }
  }

  fetchData(artistName, trackName) {   

    NProgress.start();

    Train.fetchTrack({artist: artistName, track: trackName})
    .then((track) => {
      this.setState({track, artistName, trackName, albumName: track.album});
      NProgress.done();
    }).catch((e) => {
      NProgress.done();
      Notification.show('Error loading track data', 'error');
    });

    let userId = User.getId();

    if (userId) {
      Train.fetchUserTrack({user: userId, artist: artistName, track: trackName})
      .then((userData) => {
        this.setState({userData});
      })
      .catch((error) => {
        this.setState({userData: {}});
      });
    }

  }

  componentDidMount() {
    let artist = decodeURIComponent(this.props.match.params.artist);
    let track = decodeURIComponent(this.props.match.params.track);
    this.fetchData(artist, track);
  }

  componentWillReceiveProps(newProps) {
    let artist = decodeURIComponent(newProps.match.params.artist);
    let track = decodeURIComponent(newProps.match.params.track);
    if (artist !== this.state.artistName || track !== this.state.trackName) {
      this.setState({track: undefined, artistName: undefined, trackName: undefined});
      this.fetchData(artist, track);    
    }
  }

  love() {

    let loggedIn = User.isLoggedIn();

    if (loggedIn) {

      let userData = this.state.userData;

      let artist = this.state.artistName;
      let track = this.state.trackName;

      let action = userData.loved ? 'Unloved' : 'Loved';

      GoogleAnalytics.event({
        category: 'Track',
        action: action,
        label: `${artist} - ${track}`
      });

      Train.loveTrack({track: this.state.track, status: !userData.loved})
      .then(() => {
        Notification.show(`${action} ${artist} - ${track}`, 'success');
        userData.loved = !userData.loved
        this.setState({userData});
      });
    }
    
  }

  render() {

    let track = this.state.track;
    let userData = this.state.userData || {};

    if (!track) {
      return <div className="elementPage"></div>;
    }

    let imageStyle = {
      backgroundImage: `url(${track.img})`
    };

    let albumBlock = (
      track.album && track.album.length > 0 &&
      <span className="album"> found in <Link to={`/artists/${this.state.artistName}/albums/${this.state.albumName}`}><b>{this.state.albumName}</b></Link></span>
    );

    return (
 
      <div className="elementPage">

        <div className="header">
          <div className="profileImage square" style={imageStyle} >
            <i onClick={this.love.bind(this)} className={`loved fontastic icon-heart clickable ${userData.loved ? 'active' : ''}`}></i>
          </div>

          <div className="content">

            <h1>{this.state.trackName}</h1><PlayButton type={'track'} element={track}/>
            
            <br/>

            <div className="stats">
              <span>by <Link to={`/artists/${this.state.artistName}`}><b>{this.state.artistName}</b></Link></span>{albumBlock}<span> | </span>
              <span><b>Listeners</b> {NumberUtils.abbreviation(track.stats.listeners)}</span>
              <span><b>Plays</b> {NumberUtils.abbreviation(track.stats.playcount)}</span>
              {userData.playcount !== undefined && <span><b>Your plays</b> {NumberUtils.abbreviation(userData.playcount)}</span>}
            </div>

            <TagList tags={track.topTags} selector={true}/>

            <ElementShortcuts type={'track'} element={track} userData={userData}/>

          </div>

        </div>


        <Grid title="Similar tracks" type="track" playable={true} carousel={true} elements={track.similarTracks}/>

      </div>
              
    ); 

  }
}

export default Track;



// WEBPACK FOOTER //
// ./src/js/components/track/Track.jsx